// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfx_a"};